import {TranslationInterpreter} from '../../TranslationProvider/TranslationContext';

export function getFormatOptions(t: TranslationInterpreter) {
  return [
    {label: t('richText.formats.heading1'), value: 'h1' as const},
    {label: t('richText.formats.heading2'), value: 'h2' as const},
    {label: t('richText.formats.heading3'), value: 'h3' as const},
    {label: t('richText.formats.paragraph'), value: 'p' as const},
    {label: t('richText.formats.quote'), value: 'blockquote' as const},
  ];
}
